// Beta home: each redesigned section ships behind its own toggle so they can be turned on independently.
export const HOME_HERO_V2_TOGGLE = 'home_hero_v2';
export const HOME_SOFTWARE_SECTION_V2_TOGGLE = 'home_software_v2';
